"use client";
import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const WhatweBanner = () => {
  const settings = {
    dots: true,
    arrows: false,
     infinite: true,
     speed: 500,
     autoplay: true, // Enable autoplay
     autoplaySpeed: 2000,
     slidesToShow: 3,
     slidesToScroll: 1,
     responsive: [
       {
         breakpoint: 1024,
         settings: {
           slidesToShow: 3,
           slidesToScroll: 3,
          
         },
       },
       {
         breakpoint: 769,
         settings: {
           slidesToShow: 2,
           slidesToScroll: 2,
           initialSlide: 2,
         },
       },
       {
         breakpoint: 480,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
         },
       },
     ],
   };
 
   useEffect(() => {
     const adjustHeights = () => {
       const items = document.querySelectorAll(".topsectslider_item");
       if (items.length === 0) return;
 
       let maxHeight = 0;
 
       // Reset heights for recalculation
       items.forEach((item) => {
         item.style.height = "auto";
       });
 
       // Find the tallest element
       items.forEach((item) => {
         const itemHeight = item.offsetHeight;
         if (itemHeight > maxHeight) maxHeight = itemHeight;
       });
 
       // Apply tallest height to all items
       items.forEach((item) => {
         item.style.height = `${maxHeight}px`;
       });
     };
 
     // Delay adjustment to ensure rendering
     setTimeout(() => {
       adjustHeights();
     }, 100);
 
     // Handle resize
     window.addEventListener("resize", adjustHeights);
 
     return () => {
       window.removeEventListener("resize", adjustHeights);
     };
   }, []);

  return (
    <div className="slider-container about_topsectslider1">
    <Slider {...settings}>
      <div>
        <div className="topsectslider_item">
          <div className="circle_top">1</div>
          <div className="topsectslider_itemmid">
            <h3 className="indus_hd1">Production optimization</h3>
            <p className="indus_desc1">Streamline your manufacturing process from start to finish. Our analytics solutions provide insights into bottlenecks, machine performance, and workflow inefficiencies, helping you enhance throughput, reduce waste, and improve overall productivity.</p>
          </div>
        </div>
      </div>
      <div>
        <div className="topsectslider_item">
          <div className="circle_top">2</div>
          <div className="topsectslider_itemmid">
            <h3 className="indus_hd1">Predictive maintenance</h3>
            <p className="indus_desc1">Avoid costly downtime with predictive maintenance. We use machine learning to analyze historical performance data, enabling you to predict equipment failures before they happen, extending machine life, and improving operational reliability.</p>
          </div>
        </div>
      </div>
      <div>
        <div className="topsectslider_item">
          <div className="circle_top">3</div>
          <div className="topsectslider_itemmid">
            <h3 className="indus_hd1">Supply chain & inventory management</h3>
            <p className="indus_desc1">Balance supply with demand by optimizing your inventory levels. With real-time insights into demand patterns, supplier performance, and inventory turnover, we help you minimize stockouts and avoid excess inventory, ensuring smooth production flow.</p>
          </div>
        </div>
      </div>
      <div>
        <div className="topsectslider_item">
          <div className="circle_top">4</div>
          <div className="topsectslider_itemmid">
            <h3 className="indus_hd1">Quality control & defect cetection</h3>
            <p className="indus_desc1">Ensure consistent quality with advanced analytics for defect detection and root cause analysis. Our solutions identify quality issues early, reducing rework and scrap, while improving customer satisfaction and product reliability.</p>
          </div>
        </div>
      </div>
      <div>
        <div className="topsectslider_item">
          <div className="circle_top">5</div>
          <div className="topsectslider_itemmid">
            <h3 className="indus_hd1">Energy management & sustainability</h3>
            <p className="indus_desc1">Reduce energy consumption and meet sustainability goals with data-driven energy management. We analyze energy use across your facilities, helping you identify areas for reduction, optimize resource usage, and lower costs.</p>
          </div>
        </div>
      </div>
      <div>
        <div className="topsectslider_item">
          <div className="circle_top">6</div>
          <div className="topsectslider_itemmid">
            <h3 className="indus_hd1">Workforce productivity analytics</h3>
            <p className="indus_desc1">Boost workforce efficiency and safety with insights into labour productivity, skill utilization, and work environment optimization. By analyzing workforce data, we help you improve labour allocation, reduce turnover, and promote a safer, more efficient workplace.</p>
          </div>
        </div>
      </div>

    </Slider >
  </div >
  );
};

export default WhatweBanner;
